import DuelFind from './DuelFind';
export default DuelFind;